import { Button, Stack, Typography } from '@mui/material';
import { AuthForm } from 'hooks/useAuthForm';
import IdentifierField from './IdentifierField';
import SubmitError from './SubmitError';

export default function ResetSendForm({ auth }: { auth: AuthForm }) {
  const { form, loading, submitError, fieldErrors } = auth;

  return (
    <Stack
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        auth.handleSendResetOtp();
      }}
      spacing={2}
    >
      <Typography variant="body1" fontWeight={500}>
        Сброс пароля
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Введите {auth.fieldLabel.toLowerCase()} — отправим код для создания нового пароля
      </Typography>
      <IdentifierField
        otpStrategy={auth.otpStrategy}
        value={form.resetIdentifier}
        onChange={(e) => {
          auth.updateForm({ resetIdentifier: e.target.value });
          auth.setFieldError('resetIdentifier', null);
          auth.setSubmitError(null);
        }}
        onBlur={() =>
          auth.setFieldError(
            'resetIdentifier',
            form.resetIdentifier.length === 0
              ? null
              : auth.isValidIdentifier(form.resetIdentifier)
              ? null
              : auth.fieldInvalidError
          )
        }
        error={fieldErrors.resetIdentifier}
        placeholder={auth.fieldPlaceholder}
        autoComplete={auth.fieldAutoComplete}
        label={auth.fieldLabel}
        autoFocus
      />
      <SubmitError error={submitError} />
      <Button
        fullWidth
        variant="contained"
        color="primary"
        size="large"
        type="submit"
        disabled={!form.resetIdentifier || loading}
      >
        {loading ? 'Отправка...' : 'Отправить код'}
      </Button>
    </Stack>
  );
}
